// 完整地点列表（静态），中国六个馆中文置顶
// 备注：value 与 CEAC 下拉值一致；text 为显示文案

export const LOCATIONS = [
  // 置顶（中国）
  { value: 'BEJ', text: '中国，北京' },
  { value: 'SHG', text: '中国，上海' },
  { value: 'GUZ', text: '中国，广州' },
  { value: 'CHE', text: '中国，成都' },
  { value: 'SNY', text: '中国，沈阳' },
  { value: 'WUH', text: '中国，武汉' },

  // 以下为原始顺序的完整列表（去掉 "- SELECT ONE -"）
  { value: 'KBL', text: 'AFGHANISTAN, KABUL' },
  { value: 'TIA', text: 'ALBANIA, TIRANA' },
  { value: 'ALG', text: 'ALGERIA, ALGIERS' },
  { value: 'LUA', text: 'ANGOLA, LUANDA' },
  { value: 'BNS', text: 'ARGENTINA, BUENOS AIRES' },
  { value: 'YRV', text: 'ARMENIA, YEREVAN' },
  { value: 'MLB', text: 'AUSTRALIA, MELBOURNE' },
  { value: 'PRT', text: 'AUSTRALIA, PERTH' },
  { value: 'SYD', text: 'AUSTRALIA, SYDNEY' },
  { value: 'VNN', text: 'AUSTRIA, VIENNA' },
  { value: 'BKU', text: 'AZERBAIJAN, BAKU' },
  { value: 'NSS', text: 'BAHAMAS, NASSAU' },
  { value: 'MNA', text: 'BAHRAIN, MANAMA' },
  { value: 'DHK', text: 'BANGLADESH, DHAKA' },
  { value: 'BGN', text: 'BARBADOS, BRIDGETOWN' },
  { value: 'MSK', text: 'BELARUS, MINSK' },
  { value: 'BRS', text: 'BELGIUM, BRUSSELS' },
  { value: 'BLZ', text: 'BELIZE, BELMOPAN' },
  { value: 'COT', text: 'BENIN, COTONOU' },
  { value: 'HML', text: 'BERMUDA, HAMILTON' },
  { value: 'LPZ', text: 'BOLIVIA, LA PAZ' },
  { value: 'SAR', text: 'BOSNIA-HERZEGOVINA, SARAJEVO' },
  { value: 'GAB', text: 'BOTSWANA, GABORONE' },
  { value: 'BRA', text: 'BRAZIL, BRASILIA' },
  { value: 'PTA', text: 'BRAZIL, PORTO ALEGRE' },
  { value: 'RCF', text: 'BRAZIL, RECIFE' },
  { value: 'RDJ', text: 'BRAZIL, RIO DE JANEIRO' },
  { value: 'SPL', text: 'BRAZIL, SAO PAULO' },
  { value: 'BSB', text: 'BRUNEI, BANDAR SERI BEGAWAN' },
  { value: 'SOF', text: 'BULGARIA, SOFIA' },
  { value: 'OUG', text: 'BURKINA FASO, OUAGADOUGOU' },
  { value: 'RNG', text: 'BURMA, RANGOON' },
  { value: 'BUJ', text: 'BURUNDI, BUJUMBURA' },
  { value: 'PIA', text: 'CABO VERDE, PRAIA' },
  { value: 'PHP', text: 'CAMBODIA, PHNOM PENH' },
  { value: 'YDE', text: 'CAMEROON, YAOUNDE' },
  { value: 'CLG', text: 'CANADA, CALGARY' },
  { value: 'HLF', text: 'CANADA, HALIFAX' },
  { value: 'MTL', text: 'CANADA, MONTREAL' },
  { value: 'OTT', text: 'CANADA, OTTAWA' },
  { value: 'QBC', text: 'CANADA, QUEBEC' },
  { value: 'TRT', text: 'CANADA, TORONTO' },
  { value: 'VAC', text: 'CANADA, VANCOUVER' },
  { value: 'NDJ', text: 'CHAD, N`DJAMENA' },
  { value: 'SNT', text: 'CHILE, SANTIAGO' },
  { value: 'BGT', text: 'COLOMBIA, BOGOTA' },
  { value: 'BRZ', text: 'CONGO, BRAZZAVILLE' },
  { value: 'KIN', text: 'CONGO, KINSHASA' },
  { value: 'SNJ', text: 'COSTA RICA, SAN JOSE' },
  { value: 'ABJ', text: 'COTE D`IVORIE, ABIDJAN' },
  { value: 'ZGB', text: 'CROATIA, ZAGREB' },
  { value: 'HAV', text: 'CUBA, HAVANA' },
  { value: 'CRC', text: 'CURACAO, CURACAO' },
  { value: 'NCS', text: 'CYPRUS, NICOSIA' },
  { value: 'PRG', text: 'CZECH REPUBLIC, PRAGUE' },
  { value: 'CPN', text: 'DENMARK, COPENHAGEN' },
  { value: 'DJI', text: 'DJIBOUTI, DJIBOUTI' },
  { value: 'SDO', text: 'DOMINICAN REPUBLIC, SANTO DOMINGO' },
  { value: 'GYQ', text: 'ECUADOR, GUAYAQUIL' },
  { value: 'QTO', text: 'ECUADOR, QUITO' },
  { value: 'CRO', text: 'EGYPT, CAIRO' },
  { value: 'SNS', text: 'EL SALVADOR, SAN SALVADOR' },
  { value: 'LND', text: 'ENGLAND, LONDON' },
  { value: 'MBO', text: 'EQUATORIAL GUINEA, MALABO' },
  { value: 'ASM', text: 'ERITREA, ASMARA' },
  { value: 'TAL', text: 'ESTONIA, TALLINN' },
  { value: 'MBA', text: 'ESWATINI, MBABANE' },
  { value: 'ADD', text: 'ETHIOPIA, ADDIS ABABA' },
  { value: 'SUV', text: 'FIJI, SUVA' },
  { value: 'HLS', text: 'FINLAND, HELSINKI' },
  { value: 'PRS', text: 'FRANCE, PARIS' },
  { value: 'LIB', text: 'GABON, LIBREVILLE' },
  { value: 'BAN', text: 'GAMBIA, BANJUL' },
  { value: 'TBL', text: 'GEORGIA, TBILISI' },
  { value: 'BRL', text: 'GERMANY, BERLIN' },
  { value: 'FRN', text: 'GERMANY, FRANKFURT' },
  { value: 'MUN', text: 'GERMANY, MUNICH' },
  { value: 'ACC', text: 'GHANA, ACCRA' },
  { value: 'ATH', text: 'GREECE, ATHENS' },
  { value: 'GTM', text: 'GUATEMALA, GUATEMALA CITY' },
  { value: 'CRY', text: 'GUINEA, CONAKRY' },
  { value: 'GEO', text: 'GUYANA, GEORGETOWN' },
  { value: 'PTP', text: 'HAITI, PORT-AU-PRINCE' },
  { value: 'TGG', text: 'HONDURAS, TEGUCIGALPA' },
  { value: 'HNK', text: 'HONG KONG' },
  { value: 'BDP', text: 'HUNGARY, BUDAPEST' },
  { value: 'RKJ', text: 'ICELAND, REYKJAVIK' },
  { value: 'MDR', text: 'INDIA, CHENNAI' },
  { value: 'HYD', text: 'INDIA, HYDERABAD' },
  { value: 'CLC', text: 'INDIA, KOLKATA' },
  { value: 'BMB', text: 'INDIA, MUMBAI' },
  { value: 'NWD', text: 'INDIA, NEW DELHI' },
  { value: 'JAK', text: 'INDONESIA, JAKARTA' },
  { value: 'SRB', text: 'INDONESIA, SURABAYA' },
  { value: 'BGH', text: 'IRAQ, BAGHDAD' },
  { value: 'ERB', text: 'IRAQ, ERBIL' },
  { value: 'DBL', text: 'IRELAND, DUBLIN' },
  { value: 'TLV', text: 'ISRAEL, TEL AVIV' },
  { value: 'FLR', text: 'ITALY, FLORENCE' },
  { value: 'MLN', text: 'ITALY, MILAN' },
  { value: 'NPL', text: 'ITALY, NAPLES' },
  { value: 'RME', text: 'ITALY, ROME' },
  { value: 'KNG', text: 'JAMAICA, KINGSTON' },
  { value: 'FKK', text: 'JAPAN, FUKUOKA' },
  { value: 'NHA', text: 'JAPAN, NAHA' },
  { value: 'KBO', text: 'JAPAN, OSAKA' },
  { value: 'SPP', text: 'JAPAN, SAPPORO' },
  { value: 'TKY', text: 'JAPAN, TOKYO' },
  { value: 'JRS', text: 'JERUSALEM' },
  { value: 'AMM', text: 'JORDAN, AMMAN' },
  { value: 'ATA', text: 'KAZAKHSTAN, ALMATY' },
  { value: 'AST', text: 'KAZAKHSTAN, ASTANA' },
  { value: 'NRB', text: 'KENYA, NAIROBI' },
  { value: 'PRI', text: 'KOSOVO, PRISTINA' },
  { value: 'KWT', text: 'KUWAIT, KUWAIT CITY' },
  { value: 'BKK', text: 'KYRGYZSTAN, BISHKEK' },
  { value: 'VNT', text: 'LAOS, VIENTIANE' },
  { value: 'RGA', text: 'LATVIA, RIGA' },
  { value: 'BRT', text: 'LEBANON, BEIRUT' },
  { value: 'MAS', text: 'LESOTHO, MASERU' },
  { value: 'MRV', text: 'LIBERIA, MONROVIA' },
  { value: 'VIL', text: 'LITHUANIA, VILNIUS' },
  { value: 'LXM', text: 'LUXEMBOURG, LUXEMBOURG' },
  { value: 'ANT', text: 'MADAGASCAR, ANTANANARIVO' },
  { value: 'LIL', text: 'MALAWI, LILONGWE' },
  { value: 'KLL', text: 'MALAYSIA, KUALA LUMPUR' },
  { value: 'BAM', text: 'MALI, BAMAKO' },
  { value: 'VLL', text: 'MALTA, VALLETTA' },
  { value: 'MAJ', text: 'MARSHALL ISLANDS, MAJURO' },
  { value: 'NUK', text: 'MAURITANIA, NOUAKCHOTT' },
  { value: 'PTL', text: 'MAURITIUS, PORT LOUIS' },
  { value: 'CDJ', text: 'MEXICO, CIUDAD JUAREZ' },
  { value: 'GDL', text: 'MEXICO, GUADALAJARA' },
  { value: 'HER', text: 'MEXICO, HERMOSILLO' },
  { value: 'MTM', text: 'MEXICO, MATAMOROS' },
  { value: 'MER', text: 'MEXICO, MERIDA' },
  { value: 'MEX', text: 'MEXICO, MEXICO CITY' },
  { value: 'MTR', text: 'MEXICO, MONTERREY' },
  { value: 'NGL', text: 'MEXICO, NOGALES' },
  { value: 'NVL', text: 'MEXICO, NUEVO LAREDO' },
  { value: 'TJT', text: 'MEXICO, TIJUANA' },
  { value: 'KOL', text: 'MICRONESIA, KOLONIA' },
  { value: 'CHS', text: 'MOLDOVA, CHISINAU' },
  { value: 'ULN', text: 'MONGOLIA, ULAANBAATAR' },
  { value: 'POD', text: 'MONTENEGRO, PODGORICA' },
  { value: 'CSB', text: 'MOROCCO, CASABLANCA' },
  { value: 'MAP', text: 'MOZAMBIQUE, MAPUTO' },
  { value: 'WHK', text: 'NAMIBIA, WINDHOEK' },
  { value: 'KDU', text: 'NEPAL, KATHMANDU' },
  { value: 'AMS', text: 'NETHERLANDS, AMSTERDAM' },
  { value: 'USN', text: 'NEW YORK, NY - USA' },
  { value: 'ACK', text: 'NEW ZEALAND, AUCKLAND' },
  { value: 'MNG', text: 'NICARAGUA, MANAGUA' },
  { value: 'NMY', text: 'NIGER, NIAMEY' },
  { value: 'ABU', text: 'NIGERIA, ABUJA' },
  { value: 'LGS', text: 'NIGERIA, LAGOS' },
  { value: 'SKO', text: 'NORTH MACEDONIA, SKOPJE' },
  { value: 'BLF', text: 'NORTHERN IRELAND, BELFAST' },
  { value: 'OSL', text: 'NORWAY, OSLO' },
  { value: 'MST', text: 'OMAN, MUSCAT' },
  { value: 'ISL', text: 'PAKISTAN, ISLAMABAD' },
  { value: 'KRC', text: 'PAKISTAN, KARACHI' },
  { value: 'LHR', text: 'PAKISTAN, LAHORE' },
  { value: 'KOR', text: 'PALAU, KOROR' },
  { value: 'PNM', text: 'PANAMA, PANAMA CITY' },
  { value: 'PTM', text: 'PAPUA NEW GUINEA, PORT MORESBY' },
  { value: 'ASN', text: 'PARAGUAY, ASUNCION' },
  { value: 'LMA', text: 'PERU, LIMA' },
  { value: 'MNL', text: 'PHILIPPINES, MANILA' },
  { value: 'KRK', text: 'POLAND, KRAKOW' },
  { value: 'WRW', text: 'POLAND, WARSAW' },
  { value: 'LSB', text: 'PORTUGAL, LISBON' },
  { value: 'DOH', text: 'QATAR, DOHA' },
  { value: 'BCH', text: 'ROMANIA, BUCHAREST' },
  { value: 'MOS', text: 'RUSSIA, MOSCOW' },
  { value: 'VLA', text: 'RUSSIA, VLADIVOSTOK' },
  { value: 'YEK', text: 'RUSSIA, YEKATERINBURG' },
  { value: 'KGL', text: 'RWANDA, KILGALI' },
  { value: 'APA', text: 'SAMOA, APIA' },
  { value: 'DHR', text: 'SAUDI ARABIA, DHAHRAN' },
  { value: 'JDD', text: 'SAUDI ARABIA, JEDDAH' },
  { value: 'RID', text: 'SAUDI ARABIA, RIYADH' },
  { value: 'DKR', text: 'SENEGAL, DAKAR' },
  { value: 'BLG', text: 'SERBIA, BELGRADE' },
  { value: 'FTN', text: 'SIERRA LEONE, FREETOWN' },
  { value: 'SGP', text: 'SINGAPORE, SINGAPORE' },
  { value: 'BTS', text: 'SLOVAKIA, BRATISLAVA' },
  { value: 'LJU', text: 'SLOVENIA, LJUBLJANA' },
  { value: 'CPT', text: 'SOUTH AFRICA, CAPE TOWN' },
  { value: 'DRB', text: 'SOUTH AFRICA, DURBAN' },
  { value: 'JHN', text: 'SOUTH AFRICA, JOHANNESBURG' },
  { value: 'SEO', text: 'SOUTH KOREA, SEOUL' },
  { value: 'JBA', text: 'SOUTH SUDAN, JUBA' },
  { value: 'MDD', text: 'SPAIN, MADRID' },
  { value: 'CLM', text: 'SRI LANKA, COLOMBO' },
  { value: 'KHT', text: 'SUDAN, KHARTOUM' },
  { value: 'PRM', text: 'SURINAME, PARAMARIBO' },
  { value: 'STK', text: 'SWEDEN, STOCKHOLM' },
  { value: 'BEN', text: 'SWITZERLAND, BERN' },
  { value: 'TAI', text: 'TAIWAN, TAIPEI' },
  { value: 'DHB', text: 'TAJIKISTAN, DUSHANBE' },
  { value: 'DRS', text: 'TANZANIA, DAR ES SALAAM' },
  { value: 'BNK', text: 'THAILAND, BANGKOK' },
  { value: 'CHN', text: 'THAILAND, CHIANG MAI' },
  { value: 'DIL', text: 'TIMOR LESTE, DILI' },
  { value: 'LOM', text: 'TOGO, LOME' },
  { value: 'PTS', text: 'TRINIDAD, PORT OF SPAIN' },
  { value: 'TNS', text: 'TUNISIA, TUNIS' },
  { value: 'ANK', text: 'TURKEY, ANKARA' },
  { value: 'IST', text: 'TURKEY, ISTANBUL' },
  { value: 'AKD', text: 'TURKMENISTAN, ASHGABAT' },
  { value: 'USA', text: 'U.S. - DOMESTIC' },
  { value: 'KMP', text: 'UGANDA, KAMPALA' },
  { value: 'KEV', text: 'UKRAINE, KYIV' },
  { value: 'ABD', text: 'UNITED ARAB EMIRATES, ABU DHABI' },
  { value: 'DUB', text: 'UNITED ARAB EMIRATES, DUBAI' },
  { value: 'MTV', text: 'URUGUAY, MONTEVIDEO' },
  { value: 'THT', text: 'UZBEKISTAN, TASHKENT' },
  { value: 'HAN', text: 'VIETNAM, HANOI' },
  { value: 'HCM', text: 'VIETNAM, HO CHI MINH CITY' },
  { value: 'DPT', text: 'WASHINGTON, DC - USA' },
  { value: 'LUS', text: 'ZAMBIA, LUSAKA' },
  { value: 'HRE', text: 'ZIMBABWE, HARARE' },
];

